<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import FleetCategory from './components/fleetCategory'
import FleetType from './components/fleetType'
import Manufacturer from './components/manufacture'
import Model from './components/model'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Jenis Kendaraan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    FleetCategory,
    FleetType,
    Manufacturer,
    Model,
  },
  mixins: [Helper],
  data() {
    return {
      sensors: [],
      pinCodes: [],
      pinCommands: [],
      deviceCommands: [],
      deviceTypes: {
        deviceType: [],
      },
    }
  },
  computed: {
    title() {
      return this.$t('task.column.vehicleType')
    },
  },
  methods: {
    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">{{ $t('master.textVehicleType') }}</p>
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ $t('task.column.vehicleType') }}</span>
            </template>
            <FleetType />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">
                {{ $t('master.form.fleet.fleetCategory') }}
              </span>
            </template>
            <FleetCategory />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ $t('master.list.fleetType.model') }}</span>
            </template>
            <Model />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">
                {{ $t('master.list.fleetType.manufacturer') }}
              </span>
            </template>
            <Manufacturer />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
